import { isVisible } from './utils';

const moduleName = 'menu';

export function menu () {
    const menu = document.querySelector('.js-mob-menu');
    const openMenuBtn = document.querySelector('.js-open-mob-menu');

    const openMenu = (btn, menu) => {
        if(btn && menu) {
            btn.classList.add('_active');
            menu.classList.remove('_hidden');
            menu.classList.add('_visible');
            document.body.classList.add('has-menu');
        }
    }

    const closeMenu = (btn, menu) => {
        if(btn && menu) {
            menu.classList.add('_hidden');
            setTimeout(function () {
                menu.classList.remove('_visible');
                menu.classList.remove('_hidden');
                document.body.classList.remove('has-menu');
            }, 300);
            btn.classList.remove('_active');
        }
    }

    if (menu && openMenuBtn) {
        openMenuBtn.addEventListener('click', function () {
            if (isVisible(menu)) {
                closeMenu(openMenuBtn, menu);
            } else {
                openMenu(openMenuBtn, menu);
            }
        });
    }
}
